// Persists the in-flight Link token across the OAuth full-page redirect to
// /plaid-oauth (React state is lost) so the return handler can resume Link.

const STORAGE_KEY = "wieldy.plaid.oauth";

export interface PlaidOAuthState {
  linkToken: string;
  mode: "connect" | "reauth" | "add-accounts";
  connectionId?: string;
}

export function savePlaidOAuthState(state: PlaidOAuthState): void {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(state));
  } catch {
    // Storage unavailable (private mode/quota) — OAuth banks just won't resume.
  }
}

export function loadPlaidOAuthState(): PlaidOAuthState | null {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    return raw ? (JSON.parse(raw) as PlaidOAuthState) : null;
  } catch {
    return null;
  }
}

export function clearPlaidOAuthState(): void {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch {
    // no-op
  }
}

export function isPlaidOAuthRedirect(): boolean {
  return new URLSearchParams(window.location.search).has("oauth_state_id");
}
